const NS = 'http://www.w3.org/2000/svg';

/** Paint opt-in system annotations below every drawing object. Keep the live
 * nodes/listeners in their owner layer for editing and cached navigation.
 * GPU workspaces supply a separate SVG below their transparent canvas.
 */
export function syncPlanBackground(svg, target = svg) {
  if (!svg || !target) return;
  target.querySelector(':scope > .plan-background-visuals')?.remove();
  if (target !== svg) target.setAttribute('viewBox', svg.getAttribute('viewBox'));
  const layer = svg.ownerDocument.createElementNS(NS, 'g');
  layer.setAttribute('class', 'plan-background-visuals');
  layer.setAttribute('pointer-events', 'none');
  for (const source of svg.querySelectorAll('[data-plan-background="true"]')) {
    // A previous navigation frame may reuse these same owner nodes.
    source.style.removeProperty('opacity');
    let copy = source.cloneNode(true);
    copy.removeAttribute('data-plan-background');
    for (const node of [copy, ...copy.querySelectorAll('*')]) {
      node.removeAttribute('id');
      node.setAttribute('pointer-events', 'none');
    }
    // Preserve layer visibility and cached pan/zoom transforms.
    for (let ancestor = source.parentElement; ancestor && ancestor !== svg; ancestor = ancestor.parentElement) {
      const wrapper = ancestor.cloneNode(false);
      wrapper.removeAttribute('id');
      wrapper.append(copy);
      copy = wrapper;
    }
    layer.append(copy);
    source.style.opacity = '0';
  }
  target.prepend(layer);
}
